{
  "checkInLocationIsOutsideThe": "You are {{0}} m from the allowed check-in area (office limit is {{1}} m). Move closer, enable precise location on your phone, or ask HR to verify the office coordinates and radius.",
  "checkOutLocationIsOutsideThe": "You are {{0}} m from the allowed check-out area (office limit is {{1}} m). Move closer, enable precise location on your phone, or ask HR to verify the office coordinates and radius.",
  "geoCheckInRequiresLatitudeAnd": "Location is required for geo attendance. Allow location access in your browser, turn on GPS, and try again.",
  "dashboard": {
    "title": "HR Dashboard",
    "payrollRuns": "Payroll runs",
    "openPositions": "Open positions",
    "employeesReady": "Employees ready",
    "pendingAttendance": "Pending attendance",
    "pendingTimesheets": "Pending timesheets",
    "pendingAllowances": "Pending allowances",
    "pendingExpenses": "Pending expenses",
    "pendingClaims": "Pending claims",
    "payrollReady": "Payroll ready",
    "payrollExceptions": "Payroll exceptions",
    "totalPayrollCost": "Total payroll cost",
    "allowanceCost": "Allowance cost",
    "expenseCost": "Expense cost",
    "claimCost": "Claim cost"
  },
  "attendance": {
    "title": "Attendance and Leave",
    "tabs": {
      "attendance": "Attendance",
      "leave": "Leave",
      "overtime": "Overtime"
    },
    "recordTabs": {
      "all": "All",
      "attendance": "Attendance",
      "leave": "Leave"
    },
    "newRecord": "New record",
    "addRecord": "Add record",
    "recordType": "Record type",
    "aria": {
      "attendanceAndLeave": "Attendance and leave"
    },
    "detail": {
      "checkIn": "Check in",
      "checkOut": "Check out",
      "overtime": "OT"
    },
    "status": {
      "present": "Present",
      "absent": "Absent",
      "late": "Late",
      "halfDay": "Half day",
      "wfh": "Work from home",
      "holiday": "Holiday",
      "weekend": "Weekend"
    },
    "leaveStatus": {
      "pending": "Pending",
      "returned": "Returned",
      "submitted": "Submitted",
      "approved": "Approved",
      "rejected": "Rejected",
      "cancelled": "Cancelled"
    },
    "durationMode": {
      "fullDay": "Full day",
      "halfDay": "Half day",
      "hourly": "Hourly",
      "shift": "Specific shift"
    },
    "metrics": {
      "worked": "Worked",
      "leave": "Leave",
      "overtime": "OT"
    },
    "actions": {
      "recordAttendance": "Record attendance",
      "createLeave": "Create leave",
      "checkOut": "Check out",
      "geoCheckOut": "Geo check-out",
      "pendingApproval": "Pending approval"
    },
    "kind": {
      "attendance": "Attendance",
      "overtime": "Overtime"
    },
    "hints": {
      "bulkAttendance": "Record the same attendance entry for one or more employees.",
      "bulkLeave": "Create the same leave request for one or more employees."
    },
    "empty": {
      "noEmployees": "No employees in your visibility scope — adjust filters or hierarchy."
    },
    "toast": {
      "checkOutRecorded": "Check-out recorded",
      "attendanceRecorded": "Attendance recorded",
      "leaveCreated": "Leave request created",
      "cancellationSubmitted": "Cancellation submitted for approval",
      "leaveCancelled": "Leave cancelled",
      "attendanceCancelled": "Attendance cancelled",
      "overtimeCancelled": "Overtime cancelled",
      "selectEmployee": "Select at least one employee"
    },
    "errors": {
      "checkInRequired": "Check-in time is required",
      "checkOutAfterCheckIn": "Check-out must be after check-in",
      "overtimeTypeRequired": "Select an overtime type when worked time exceeds expected hours",
      "leaveTypeRequired": "Leave type and at least one day are required",
      "leaveTypeOnly": "Leave type is required",
      "leaveDayRequired": "Select at least one leave day",
      "leaveReasonRequired": "Leave reason is required",
      "attachmentUploadFailed": "Failed to upload attachment",
      "checkOutFailed": "Check-out failed",
      "markAttendanceFailed": "Failed to mark attendance",
      "createLeaveFailed": "Failed to create leave",
      "cancelFailed": "Cancel failed"
    }
  },
  "payroll": {
    "title": "Payroll",
    "newRun": "New payroll run",
    "periodStart": "Period start",
    "periodEnd": "Period end",
    "createRun": "Create run",
    "workflowHint": "Workflow: create run → approve → calculate. Calculation uses org formulas when configured, otherwise a statutory fallback rate.",
    "formulasActive": "{{count}} active formula(s): {{codes}}",
    "noFormulasFallback": "No country formulas — fallback statutory rate will apply",
    "calculate": "Calculate",
    "calculateUsingFormulas": "Calculate using {{count}} formula(s)",
    "calculateStatutoryFallback": "Calculate using statutory fallback rate",
    "approveBeforeCalculate": "Approve this run before calculating",
    "inStatutory": "IN statutory",
    "bankFile": "Bank file",
    "transactions": "Transactions",
    "transactionsModalTitle": "Payroll transactions",
    "transactionsModalTitleRun": "Transactions — {{runCode}}"
  },
  "leave": {
    "title": "Leave",
    "request": "Request leave",
    "balance": "Leave balance"
  },
  "calendar": {
    "granularity": {
      "year": "Year",
      "month": "Month",
      "week": "Week",
      "day": "Day"
    },
    "timeDisplay": {
      "hours": "Hours",
      "days": "Days",
      "both": "Both"
    },
    "weekNumber": "Week {{n}}",
    "weekShortPrefix": "W{{n}} · ",
    "employee": "Employee",
    "expected": "Expected",
    "totalHours": "Total hrs",
    "noEmployees": "No employees to display",
    "legend": {
      "workingDay": "Working day",
      "halfDay": "Half day",
      "offDay": "Off day",
      "holiday": "Holiday",
      "special": "Special",
      "worked": "Worked",
      "leave": "Leave",
      "overtime": "OT",
      "pendingApproval": "Pending approval"
    },
    "units": {
      "hoursCount": "{{value}} hrs",
      "dayCountOne": "{{value}} day",
      "dayCountOther": "{{value}} days",
      "hrsSuffix": "(hrs)",
      "daysSuffix": "(days)"
    },
    "metricHeaderHours": "{{label}} (hrs)",
    "metricHeaderDays": "{{label}} (days)",
    "marker": {
      "present": "P",
      "overtime": "OT",
      "leaveFallback": "L"
    },
    "tooltip": {
      "workedApproved": "Worked (approved)",
      "workedPending": "Worked (pending)",
      "workedRejected": "Worked (rejected)",
      "workedCancelled": "Worked (cancelled)",
      "leaveApproved": "Leave (approved)",
      "leavePending": "Leave (pending)",
      "leaveRejected": "Leave (rejected)",
      "leaveCancelled": "Leave (cancelled)",
      "overtimeApproved": "OT (approved)",
      "overtimePending": "OT (pending)",
      "overtimeRejected": "OT (rejected)",
      "overtimeCancelled": "OT (cancelled)",
      "fromAttendance": "from attendance",
      "manualRequest": "manual request",
      "punches": "({{count}} punches)",
      "late": "late {{minutes}}",
      "leaveTypeFallback": "Leave",
      "fullDay": "full day"
    },
    "overtimeMinutesLabel": "{{minutes}} {{abbrev}}",
    "overtimeBadge": "{{abbrev}} {{status}}",
    "pendingOvertimeTrend": "{{minutes}} {{abbrev}} {{label}}"
  },
  "columns": {
    "code": "Code",
    "name": "Name",
    "status": "Status",
    "actions": "Actions",
    "description": "Description",
    "color": "Color",
    "employee": "Employee",
    "shift": "Shift",
    "hours": "Hours",
    "days": "Days",
    "type": "Type",
    "date": "Date",
    "title": "Title",
    "category": "Category",
    "provider": "Provider",
    "active": "Active",
    "location": "Location",
    "email": "Email",
    "role": "Role",
    "amount": "Amount",
    "comments": "Comments",
    "level": "Level",
    "grade": "Grade",
    "start": "Start",
    "end": "End",
    "score": "Score",
    "reason": "Reason",
    "content": "Content",
    "rating": "Rating",
    "reviewer": "Reviewer",
    "cycle": "Cycle",
    "details": "Details",
    "expiry": "Expiry",
    "download": "Download",
    "claim": "Claim",
    "from": "From",
    "to": "To",
    "run": "Run",
    "gross": "Gross",
    "net": "Net",
    "product": "Product",
    "revenue": "Revenue",
    "payment": "Payment",
    "invoiceNumber": "Invoice #",
    "quantitySold": "Qty sold",
    "rate": "Rate %",
    "taxable": "Taxable",
    "tax": "Tax",
    "lines": "Lines",
    "alertQty": "Alert qty",
    "need": "Need",
    "daysLeft": "Days left",
    "invoices": "Invoices",
    "sales": "Sales",
    "organization": "Organization",
    "platforms": "Platforms",
    "paid": "Paid",
    "carryForward": "Carry forward",
    "entitlement": "Entitlement",
    "used": "Used",
    "pending": "Pending",
    "available": "Available",
    "payrollMode": "Payroll mode",
    "hoursPerDay": "Hours/day",
    "endDateRequired": "End date required",
    "trackExpiry": "Track expiry",
    "receiptRequired": "Receipt required",
    "leaveType": "Leave type",
    "policy": "Policy",
    "annualDays": "Annual days",
    "accrual": "Accrual",
    "maxConsecutive": "Max consecutive",
    "carryForwardMax": "Carry forward max",
    "backdated": "Backdated",
    "nonWorking": "Non-working",
    "workingDays": "Working days",
    "defaultHours": "Default hours",
    "employment": "Employment",
    "headcount": "Headcount",
    "positions": "Positions",
    "position": "Position",
    "relationship": "Relationship",
    "grossAmount": "Gross amount",
    "effectiveFrom": "Effective from",
    "effectiveTo": "Effective to",
    "salaryStructure": "Salary structure",
    "structureName": "Structure name",
    "applicableDay": "Applicable day",
    "netAmount": "Net amount",
    "employeeId": "Employee ID",
    "deductions": "Deductions",
    "mode": "Mode",
    "inOut": "In / out",
    "open": "Open",
    "ot": "OT",
    "worked": "Worked",
    "week": "Week",
    "course": "Course",
    "tag": "Tag",
    "nonWorkingDay": "Non-working day",
    "returnRequired": "Return required",
    "threshold": "Threshold",
    "dailyOt": "Daily OT",
    "weeklyOt": "Weekly OT",
    "billable": "Billable",
    "dayType": "Day type",
    "overallOtApproved": "Overall OT (approved)",
    "aggregateWeeklyOtCompany": "Aggregate weekly OT (company)",
    "requiredDocument": "Required document",
    "payRun": "Pay run"
  },
  "ess": {
    "tabs": {
      "home": "Home",
      "profile": "Profile",
      "schedule": "Schedule",
      "time": "Time",
      "leave": "Leave",
      "pay": "Pay",
      "approvals": "My requests"
    },
    "actions": {
      "refresh": "Refresh",
      "manualCheckOut": "Manual check-out",
      "geoCheckIn": "Geo check-in",
      "geoCheckOut": "Geo check-out",
      "updating": "Updating…",
      "openApprovalInbox": "Open approval inbox",
      "submitLeaveRequest": "Submit leave request",
      "updateDocuments": "Update documents",
      "timeAndAttendance": "Time & attendance",
      "fullSchedule": "Full schedule",
      "fullRoster": "Full roster →",
      "viewCalendar": "View calendar →",
      "viewTimeTab": "Time tab →",
      "viewLeaveTab": "Leave tab →",
      "viewPayTab": "Pay tab →",
      "viewRequestsTab": "Requests tab →",
      "viewProfileTab": "Profile →",
      "downloadPayslipAria": "Download payslip for run {{runCode}}"
    },
    "home": {
      "todayAtWork": "Today at work",
      "scheduleLoadsFromShifts": "Schedule loads from your assigned shifts and roster.",
      "manualCheckInOpen": "Manual check-in {{time}} · session open",
      "geoCheckInOpen": "Geo check-in {{time}} · session open",
      "expectedHoursMonth": "Expected hours (month)",
      "workedHoursApproved": "Worked hours (approved)",
      "overtimeApproved": "Overtime (approved)",
      "shiftAssignments": "Shift assignments",
      "companyDefault": "Company default",
      "loadingRoster": "Loading roster…",
      "loading": "Loading…",
      "requested": "{{days}} requested",
      "netAmount": "Net {{amount}}",
      "amountLabel": "Amount {{amount}}",
      "openSession": "Open",
      "workflow": "Workflow"
    },
    "documentTracking": {
      "title": "Document tracking",
      "description": "Some required documents need your attention. Upload or renew them to stay compliant."
    },
    "leave": {
      "calendarHint": "Click or drag across days to select. Only the days you pick are included — gaps are kept.",
      "scheduledLeave": "Scheduled leave",
      "calculatingLeaveImpact": "Calculating leave impact…"
    },
    "time": {
      "pendingItemsNote": "Pending items are shown separately and count toward approval before they are included in the totals above.",
      "manualSessionOpen": "Manual session open since {{time}}",
      "geoSessionOpen": "Geo session open since {{time}}",
      "modeGeo": "Geo",
      "modeManual": "Manual"
    },
    "schedule": {
      "rangeDescription": "Expected and resolved schedule for {{start}} to {{end}}"
    },
    "approvals": {
      "returnedForChanges_one": "{{count}} request returned for changes.",
      "returnedForChanges_other": "{{count}} requests returned for changes.",
      "noApprovalRequestsYet": "No approval requests yet."
    },
    "errors": {
      "geoCheckInFailed": "Could not check in — you may be outside the office area. Allow location access, move closer, or ask HR to verify the attendance location settings.",
      "geoCheckOutFailed": "Could not check out — you may be outside the office area. Allow location access, move closer, or ask HR to verify the attendance location settings."
    },
    "empty": {
      "noOpenAttendanceSession": "No open attendance session",
      "noUpcomingRoster": "No upcoming roster entries — your assigned shift or company calendar applies.",
      "noRosterThisMonth": "No roster entries this month.",
      "noAttendanceRecords": "No attendance records yet.",
      "noLeaveRequests": "No leave requests yet.",
      "noPayslips": "No payslips available yet.",
      "noApprovalRequests": "No approval requests yet.",
      "noOvertimeThisMonth": "No overtime requests this month.",
      "noExpenseClaims": "No expense claims.",
      "noTrainingAssignments": "No training assignments."
    }
  },
  "mss": {
    "loading": "Loading…",
    "stats": {
      "directReports": "Direct reports",
      "pendingLeave": "Pending leave",
      "pendingAttendance": "Pending attendance",
      "myApprovalQueue": "My approval queue"
    },
    "teamHierarchy": {
      "title": "My team hierarchy",
      "hint": "Click an employee to open profile"
    },
    "quickActions": {
      "title": "Quick actions",
      "myApprovals": "My approvals",
      "timeAttendance": "Time & attendance",
      "allEmployees": "All employees"
    },
    "actions": {
      "refresh": "Refresh"
    }
  },
  "hierarchy": {
    "noReportingHierarchy": "No reporting hierarchy",
    "assignManagersToBuild": "Assign managers to build your organization tree.",
    "you": "You",
    "viewOnly": "View only",
    "directReport_one": "{{count}} direct report",
    "directReport_other": "{{count}} direct reports",
    "employeesInTree_one": "{{count}} employee in tree",
    "employeesInTree_other": "{{count}} employees in tree",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "expandAria": "Expand {{name}}",
    "collapseAria": "Collapse {{name}}",
    "orgChart": {
      "title": "Organization chart",
      "description": "Full company reporting tree. You can open full profiles for yourself and your team; managers and peers outside your scope show a limited preview only.",
      "loading": "Loading hierarchy…",
      "empty": "No employees in the reporting tree yet. Assign a manager, or ensure employees are active and linked to this company.",
      "summaryWithViewer": "{{count}} employees · full company chart — you can open profiles for yourself and your team",
      "summaryTopDown": "{{count}} employees · top-down reporting tree"
    },
    "reportingRelationship": {
      "title": "Reporting relationship",
      "description": "Set, change, or remove an employee's direct manager. Choose \"No manager\" to clear an invalid or outdated reporting line.",
      "noManager": "No manager"
    },
    "actions": {
      "employeeDirectory": "Employee directory",
      "orgMasterData": "Org master data"
    },
    "preview": {
      "limitedTitle": "Limited employee preview",
      "managerTitle": "Reporting manager",
      "limitedDescription": "You can see this person in the hierarchy, but full HR profile details are only available for yourself and employees in your reporting line below you.",
      "managerDescription": "This is your direct reporting manager. Full HR profile details are not available from this view."
    },
    "errors": {
      "failedToAssignManager": "Failed to assign manager",
      "failedToRemoveManager": "Failed to remove manager"
    }
  },
  "directory": {
    "loadingEmployees": "Loading employees…",
    "employeesFound_one": "{{count}} employee found",
    "employeesFound_other": "{{count}} employees found",
    "noSearchResults": "No employees match your search",
    "tryDifferentSearch": "Try a different search term.",
    "hierarchySidebarHint": "Everyone in the company is listed. Open full profiles for yourself and your team; others show a limited preview.",
    "detailTabs": {
      "overview": "Overview",
      "employment": "Employment",
      "time": "Time & leave",
      "pay": "Pay & performance",
      "documents": "Documents & training"
    },
    "actions": {
      "shifts": "Shifts",
      "timeAttendance": "Time & attendance",
      "overtime": "Overtime",
      "editEmployment": "Edit employment",
      "recordLifecycleEvent": "Record lifecycle event"
    },
    "lifecycle": {
      "noEvents": "No lifecycle events recorded.",
      "present": "present"
    },
    "training": {
      "noRecords": "No training records."
    },
    "assets": {
      "noAssigned": "No assets assigned."
    }
  },
  "overtimePage": {
    "newRequest": "New overtime request",
    "requestsList": "Overtime requests",
    "bulkHint": "Request the same overtime entry for one or more employees.",
    "selectEmployeeForSummary": "Select an employee to see their overall approved overtime for the chosen period.",
    "emptyWithCreate": "Adjust the employee or date range, or submit a new request above.",
    "emptyFilterOnly": "Adjust the employee or date range.",
    "toast": {
      "requested": "Overtime requested",
      "selectEmployee": "Select at least one employee"
    },
    "approval": {
      "cancellationPending": "Cancellation pending approval",
      "cancellationPendingShort": "cancellation pending"
    },
    "summaryDateRange": " · {{from}} to {{to}}",
    "typeModal": {
      "editTitle": "Edit overtime type",
      "newTitle": "New overtime type"
    },
    "attendanceFields": {
      "title": "Overtime",
      "estimatedWithType": "Estimated overtime: {{estimated}} (expected {{expected}}). Select the overtime type before saving.",
      "expectedBeyondSchedule": "Expected hours for this day: {{expected}}. Select an overtime type if the employee worked beyond schedule."
    },
    "modal": {
      "title": "Overtime",
      "titleLeaveDay": "Overtime (leave day)",
      "approved": "Approved {{minutes}}",
      "pendingApproval": "{{minutes}} pending approval"
    }
  },
  "devicesPage": {
    "deviceTypes": {
      "biometric": "Biometric",
      "rfid": "RFID",
      "qr": "QR",
      "face": "Face recognition"
    },
    "noDevices": "No devices registered."
  },
  "compensationPage": {
    "salaryStructures": "Salary structures",
    "assignToEmployee": "Assign to employee",
    "structureFallback": "Structure #{{id}}",
    "selectEmployeeToViewAssignments": "Select an employee to view their salary assignments.",
    "assignmentsForEmployee": "Salary assignments"
  },
  "statutoryPage": {
    "portals": {
      "epfo": {
        "name": "EPFO (ECR)",
        "description": "Employee Provident Fund — monthly ECR upload"
      },
      "esic": {
        "name": "ESIC",
        "description": "Employees' State Insurance contribution filing"
      },
      "traces": {
        "name": "TRACES (TDS)",
        "description": "TDS / Form 24Q reconciliation portal"
      }
    },
    "payrollRunsSection": "Payroll runs — export & auto-file",
    "downloadCsv": "Download CSV",
    "filePortal": "File {{portal}}",
    "refreshStatus": "Refresh status",
    "noPayrollRuns": "No payroll runs yet",
    "filingFailed": "{{portalCode}} filing failed"
  },
  "loansPage": {
    "newLoanRequest": "New loan request",
    "submitRequest": "Submit request"
  },
  "master": {
    "title": "HR master data",
    "description": "Configure HR masters per company — leave, employment, org units, documents, overtime, shifts, and expenses.",
    "add": "Add {{label}}",
    "loadFailed": "Failed to load HR master data",
    "yes": "Yes",
    "no": "No",
    "tabs": {
      "leave": {
        "label": "Leave types",
        "description": "Define leave categories, calendar colors, and accrual policies per company"
      },
      "employment": {
        "label": "Employment types",
        "description": "Contract types used when hiring and changing employment"
      },
      "documents": {
        "label": "Document types",
        "description": "Categories for employee document uploads and expiry tracking"
      },
      "businessUnits": {
        "label": "Business units",
        "description": "Top-level divisions used to group departments and reporting"
      },
      "departments": {
        "label": "Departments",
        "description": "Functional teams employees belong to — optional parent and business unit"
      },
      "grades": {
        "label": "Grades",
        "description": "Job levels for compensation bands and designation mapping"
      },
      "designations": {
        "label": "Designations",
        "description": "Job titles linked to a department and grade"
      },
      "overtime": {
        "label": "Overtime types",
        "description": "Classify overtime by calendar context — each company defines its own"
      },
      "shiftTypes": {
        "label": "Shift types",
        "description": "Categories for shift definitions (fixed, flexible, rotational, etc.)"
      },
      "shifts": {
        "label": "Shift definitions",
        "description": "Named shifts with hours and calendar colors for employee assignment"
      },
      "expenseTypes": {
        "label": "Expense types",
        "description": "Categories for employee expense claims and reimbursements"
      },
      "assetTypes": {
        "label": "Asset types",
        "description": "Equipment categories employees can request — laptop, phone, monitor, etc."
      },
      "assetRequests": {
        "label": "Asset requests",
        "description": "Submit and track employee equipment requests with approval workflow"
      },
      "pipelineStages": {
        "label": "Pipeline stages",
        "description": "Recruitment kanban columns — name, order, and color per company"
      }
    },
    "payrollMode": {
      "monthlySalary": "Monthly salary",
      "hourly": "Hourly",
      "contractRules": "Contract rules"
    },
    "dayClass": {
      "any": "Any day",
      "working": "Scheduled working day",
      "holiday": "Holiday",
      "weekend": "Weekend / off day"
    },
    "shifts": {
      "title": "Shift definitions",
      "description": "Named shifts with type, hours, and calendar color — used when assigning employees on the Shifts page.",
      "shiftName": "Shift name",
      "startTime": "Start time",
      "endTime": "End time",
      "calendarColor": "Calendar color",
      "createShift": "Create shift",
      "empty": "No shifts yet — create one above",
      "loadFailed": "Failed to load shifts",
      "createFailed": "Create shift failed",
      "deactivateFailed": "Failed to deactivate shift",
      "activateFailed": "Failed to activate shift"
    },
    "leavePolicy": {
      "saved": "Leave policy saved — employee balances updated from policy entitlement",
      "saveFailed": "Failed to save policy"
    },
    "modals": {
      "leaveType": {
        "edit": "Edit leave type",
        "new": "New leave type"
      },
      "employmentType": {
        "edit": "Edit employment type",
        "new": "New employment type"
      },
      "documentType": {
        "edit": "Edit document type",
        "new": "New document type"
      },
      "shiftType": {
        "edit": "Edit shift type",
        "new": "New shift type"
      },
      "expenseType": {
        "edit": "Edit expense type",
        "new": "New expense type"
      },
      "assetType": {
        "edit": "Edit asset type",
        "new": "New asset type"
      },
      "pipelineStage": {
        "edit": "Edit pipeline stage",
        "new": "New pipeline stage"
      },
      "calendarColor": "Calendar color",
      "calendarColorHint": "Used on the time & attendance calendar and leave lists.",
      "documentExpiryYes": "Yes — require ID, name, expiry & file",
      "pipelineStageCodeLocked": "Built-in stage codes cannot be changed. You can rename and recolor them."
    },
    "leavePolicyPanel": {
      "title": "Leave policies",
      "description": "Paid leave types require a policy. Unpaid leave is unlimited unless you configure a policy to cap days or add rules. Entitlement changes update employee balances automatically.",
      "configurePolicy": "Configure policy",
      "editTitle": "Edit leave policy",
      "configureTitle": "Configure leave policy",
      "optional": "Optional",
      "required": "Required",
      "notRequired": "Not required",
      "annualEntitlementHint": "Total days per year — changing this updates all employee balances",
      "backdatedNo": "No — start date must be today or future",
      "backdatedYes": "Yes — employees may apply for past dates",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "accrual": {
        "none": "No accrual",
        "monthly": "Monthly",
        "yearly": "Yearly (lump)",
        "monthlyWithDays": "Monthly ({{days}}d)",
        "yearlyLump": "Yearly lump"
      },
      "backdated": {
        "no": "No",
        "yesAny": "Yes (any past date)",
        "yesUpTo": "Yes (up to {{days}} days)"
      },
      "defaultPolicyName": "{{name}} policy"
    },
    "orgMaster": {
      "gradesHintBefore": "Set up",
      "gradesHintLink": "grades",
      "gradesHintAfter": "before designations so titles inherit the correct level.",
      "modals": {
        "businessUnit": {
          "edit": "Edit business unit",
          "add": "Add business unit"
        },
        "department": {
          "edit": "Edit department",
          "add": "Add department"
        },
        "grade": {
          "edit": "Edit grade",
          "add": "Add grade"
        },
        "designation": {
          "edit": "Edit designation",
          "add": "Add designation"
        }
      },
      "createFailed": "Failed to create {{entity}}"
    },
    "toast": {
      "leaveTypeDeactivated": "Leave type deactivated",
      "leaveTypeActivated": "Leave type activated",
      "leaveTypeUpdated": "Leave type updated",
      "leaveTypeCreated": "Leave type created",
      "employmentTypeDeactivated": "Employment type deactivated",
      "employmentTypeActivated": "Employment type activated",
      "employmentTypeUpdated": "Employment type updated",
      "employmentTypeCreated": "Employment type created",
      "documentTypeDeactivated": "Document type deactivated",
      "documentTypeActivated": "Document type activated",
      "documentTypeUpdated": "Document type updated",
      "documentTypeCreated": "Document type created",
      "overtimeTypeDeactivated": "Overtime type deactivated",
      "overtimeTypeActivated": "Overtime type activated",
      "overtimeTypeUpdated": "Overtime type updated",
      "overtimeTypeCreated": "Overtime type created",
      "shiftTypeDeactivated": "Shift type deactivated",
      "shiftTypeActivated": "Shift type activated",
      "shiftTypeUpdated": "Shift type updated",
      "shiftTypeCreated": "Shift type created",
      "shiftCreated": "Shift created",
      "shiftDeactivated": "Shift deactivated",
      "shiftActivated": "Shift activated",
      "expenseTypeDeactivated": "Expense type deactivated",
      "expenseTypeActivated": "Expense type activated",
      "expenseTypeUpdated": "Expense type updated",
      "expenseTypeCreated": "Expense type created",
      "assetTypeDeactivated": "Asset type deactivated",
      "assetTypeActivated": "Asset type activated",
      "assetTypeUpdated": "Asset type updated",
      "assetTypeCreated": "Asset type created",
      "pipelineStageDeactivated": "Pipeline stage deactivated",
      "pipelineStageActivated": "Pipeline stage activated",
      "pipelineStageUpdated": "Pipeline stage updated",
      "pipelineStageCreated": "Pipeline stage created",
      "businessUnitActivated": "Business unit activated",
      "businessUnitDeactivated": "Business unit deactivated",
      "businessUnitUpdated": "Business unit updated",
      "businessUnitCreated": "Business unit created",
      "departmentActivated": "Department activated",
      "departmentDeactivated": "Department deactivated",
      "departmentUpdated": "Department updated",
      "departmentCreated": "Department created",
      "gradeActivated": "Grade activated",
      "gradeDeactivated": "Grade deactivated",
      "gradeUpdated": "Grade updated",
      "gradeCreated": "Grade created",
      "designationActivated": "Designation activated",
      "designationDeactivated": "Designation deactivated",
      "designationUpdated": "Designation updated",
      "designationCreated": "Designation created"
    },
    "errors": {
      "nameCodeRequired": "Name and code are required",
      "shiftNameTypeRequired": "Shift name and type are required",
      "deactivateLeaveType": "Failed to deactivate leave type",
      "activateLeaveType": "Failed to activate leave type",
      "deactivateEmploymentType": "Failed to deactivate employment type",
      "activateEmploymentType": "Failed to activate employment type",
      "deactivateDocumentType": "Failed to deactivate document type",
      "activateDocumentType": "Failed to activate document type",
      "deactivateOvertimeType": "Failed to deactivate overtime type",
      "activateOvertimeType": "Failed to activate overtime type",
      "deactivateShiftType": "Failed to deactivate shift type",
      "activateShiftType": "Failed to activate shift type",
      "deactivateExpenseType": "Failed to deactivate expense type",
      "activateExpenseType": "Failed to activate expense type",
      "deactivateAssetType": "Failed to deactivate asset type",
      "activateAssetType": "Failed to activate asset type",
      "deactivatePipelineStage": "Failed to deactivate pipeline stage",
      "activatePipelineStage": "Failed to activate pipeline stage"
    }
  },
  "recruitment": {
    "title": "Recruitment",
    "loadDashboardFailed": "Failed to load recruitment dashboard",
    "tabs": {
      "dashboard": {
        "label": "Dashboard",
        "hint": "Hiring metrics, funnel, and analytics"
      },
      "workqueue": {
        "label": "Work queue",
        "hint": "Pending interviews, offers, documents, confirmations"
      },
      "planning": {
        "label": "Workforce planning",
        "hint": "Headcount requests"
      },
      "requisitions": {
        "label": "Requisitions",
        "hint": "Approved positions to fill"
      },
      "jobs": {
        "label": "Job postings",
        "hint": "Open roles candidates apply to"
      },
      "pipeline": {
        "label": "Pipeline",
        "hint": "Candidate kanban by stage"
      }
    },
    "hiringProgress": {
      "title": "Hiring progress",
      "terminalStage": "Terminal stage: {{stage}}",
      "steps": {
        "screening": "Screening",
        "assessment": "Assessment",
        "interview": "Interview",
        "selection": "Selection",
        "offer": "Offer",
        "acceptance": "Acceptance",
        "preboarding": "Preboarding",
        "onboarding": "Onboarding",
        "hire": "Employee"
      },
      "hints": {
        "terminal": "This candidate is no longer in the active hiring flow.",
        "screening": "Run auto screening, schedule assessment, then schedule an interview.",
        "interviewScheduled": "Complete the interview to move the candidate to selected.",
        "interviewed": "Candidate should advance to selected after interview completion.",
        "selectionPending": "Approve selection, then create the offer letter.",
        "selected": "Create and send the offer letter.",
        "offerPending": "Approve the offer, then accept on behalf of the candidate or share the portal link.",
        "offerSent": "Accept the offer to start preboarding and background verification.",
        "preboarding": "Complete preboarding checklist and BGV, then onboarding starts automatically.",
        "offerAccepted": "Preboarding is starting — complete documents in the candidate portal.",
        "onboarding": "Complete all onboarding tasks, approve onboarding, then create the employee record.",
        "hired": "Employee created — complete probation review when due.",
        "default": "Continue the hiring workflow."
      }
    },
    "errors": {
      "titleEmploymentRequired": "Title and employment type are required",
      "candidateNameRequired": "Candidate name is required",
      "titleRequired": "Title is required",
      "interviewDateRequired": "Interview date and time are required",
      "employmentTypeRequired": "Employment type is required",
      "possibleDuplicate": "Possible duplicate: {{name}}",
      "loadCandidateFailed": "Failed to load candidate",
      "hireFailed": "Hire failed — complete offer, preboarding, and onboarding first"
    },
    "toast": {
      "submittedForApproval": "Submitted for approval",
      "jobPostingCreated": "Job posting created",
      "requisitionCreated": "Requisition created — submit for approval from the table",
      "candidateAdded": "Candidate added",
      "manpowerSubmitted": "Manpower request submitted for approval",
      "employeeCreated": "Employee #{{id}} created",
      "alreadyHired": "Already hired as employee #{{id}}",
      "interviewScheduled": "Interview scheduled",
      "interviewCompleted": "Interview completed — candidate selected",
      "offerCreated": "Offer created — pending approval before acceptance",
      "assessmentRecorded": "Assessment recorded",
      "offerAccepted": "Offer accepted — preboarding started",
      "offerDeclined": "Offer declined",
      "preboardingComplete": "Preboarding complete — moved to onboarding",
      "onboardingApproved": "Onboarding approved — ready to hire",
      "selectionApproved": "Selection approved — you can create the offer",
      "offerApproved": "Offer approved — ready to accept",
      "autoScreeningCompleted": "Auto screening completed",
      "probationConfirmed": "Probation confirmed",
      "probationExtended": "Probation extended",
      "bgvCompleted": "BGV completed"
    }
  },
  "toast": {
    "appraisalCycleCreated": "Appraisal cycle created",
    "reviewSubmitted": "Review submitted",
    "assetRequestSubmitted": "Asset request submitted",
    "applicationSubmitted": "Application submitted",
    "expenseClaimCreated": "Expense claim created",
    "structureCreated": "Structure created",
    "salaryAssigned": "Salary assigned",
    "documentUploaded": "Document uploaded",
    "bankDetailsSaved": "Bank details saved",
    "employmentDetailsSaved": "Employment details saved",
    "holidayTypeUpdated": "Holiday type updated",
    "holidayTypeCreated": "Holiday type created",
    "holidayTypeDeactivated": "Holiday type deactivated",
    "holidayTypeActivated": "Holiday type activated",
    "weekPatternUpdated": "Week pattern updated",
    "weekPatternCreated": "Week pattern created",
    "weekPatternDeactivated": "Week pattern deactivated",
    "weekPatternActivated": "Week pattern activated",
    "lifecycleEventRecorded": "Lifecycle event recorded",
    "geoCheckOutRecorded": "Geo check-out recorded",
    "geoCheckInRecorded": "Geo check-in recorded",
    "manualCheckOutRecorded": "Manual check-out recorded",
    "leaveRequestSubmitted": "Leave request submitted",
    "360FeedbackInvitationsSent": "360 feedback invitations sent",
    "holidayUpdated": "Holiday updated",
    "holidayAdded": "Holiday added",
    "holidayRemoved": "Holiday removed",
    "onboardingStarted": "Onboarding started",
    "exitInitiated": "Exit initiated",
    "exitFinalized": "Exit finalized",
    "loanRequestSubmitted": "Loan request submitted",
    "managerRemoved": "Manager removed",
    "reportingRelationshipSaved": "Reporting relationship saved",
    "payrollRunCreated": "Payroll run created",
    "payrollCalculatedAndProcessed": "Payroll calculated and processed",
    "statutoryReportExported": "Statutory report exported",
    "setupSeededSuccessfully": "Setup seeded successfully",
    "shiftUpdated": "Shift updated",
    "shiftDayUpdated": "Shift saved for this day",
    "shiftDayCleared": "Shift cleared for this day",
    "shiftChangeCancelled": "Shift change cancelled",
    "statutoryCsvDownloaded": "Statutory CSV downloaded",
    "planCreated": "Plan created",
    "courseCreated": "Course created",
    "trainingAssigned": "Training assigned",
    "travelRequestSubmitted": "Travel request submitted",
    "overrideRemoved": "Override removed",
    "weeklyOvertimeRecalculated": "Weekly overtime recalculated",
    "monthEndWorkforceProcessCompleted": "Month-end workforce process completed",
    "portalFiling": "{{portalCode}} filing {{status}} — ref {{ref}}",
    "reportExported": "{{reportType}} exported",
    "deviceRegistered": "Device registered. API key: {{apiKey}}",
    "weeklyOtAggregated": "Weekly OT aggregated for {{count}} employees",
    "hiringPolicySaved": "Hiring policy saved for {{company}}",
    "approvalPolicySaved": "Approval policy saved for {{company}}",
    "bankDetailsSubmittedForApproval": "Bank details submitted for approval",
    "travelRequestSettled": "Travel request settled."
  },
  "errors": {
    "failedToLoadFieldPermissions": "Failed to load field permissions",
    "failedToLoadCountryPacks": "Failed to load country packs",
    "failedToLoadShiftRotations": "Failed to load shift rotations",
    "selectACycleAndEmployee": "Select a cycle and employee",
    "failedToLoadAppraisalCycles": "Failed to load appraisal cycles",
    "failedToLoadReviews": "Failed to load reviews",
    "failedToCreateCycle": "Failed to create cycle",
    "failedToSubmitReview": "Failed to submit review",
    "employeeAndAssetTypeAreRequired": "Employee and asset type are required",
    "failedToCreateAssetRequest": "Failed to create asset request",
    "failedToLoadJobs": "Failed to load jobs",
    "applicationFailed": "Application failed",
    "employeeExpenseTypeDateAndAmountAreRequired": "Employee, expense type, date, and amount are required",
    "failedToCreateExpense": "Failed to create expense",
    "failedToLoadStructures": "Failed to load structures",
    "failedToCreateStructure": "Failed to create structure",
    "assignmentFailed": "Assignment failed",
    "failedToLoadAssignments": "Failed to load salary assignments",
    "selectDocumentTypeAndFile": "Select document type and file",
    "documentNameIsRequired": "Document name is required",
    "documentIdNumberIsRequiredForThisType": "Document ID / number is required for this type",
    "expiryDateIsRequiredForThisType": "Expiry date is required for this type",
    "employeeIsRequired": "Employee is required",
    "failedToLoadDocumentTypes": "Failed to load document types",
    "uploadFailed": "Upload failed",
    "bankNameAndAccountNumberAreRequired": "Bank name and account number are required",
    "failedToSaveBankDetails": "Failed to save bank details",
    "documentFileIsNotAvailable": "Document file is not available",
    "couldNotLoadPreviewOpeningInANew": "Could not load preview — opening in a new tab",
    "failedToLoadDocuments": "Failed to load documents",
    "reportingManagerIsRequired": "Reporting manager is required",
    "anEmployeeCannotBeTheirOwnManager": "An employee cannot be their own manager",
    "failedToSaveEmploymentDetails": "Failed to save employment details",
    "codeAndNameAreRequired": "Code and name are required",
    "failedToLoadHolidayTypes": "Failed to load holiday types",
    "deactivateFailed": "Deactivate failed",
    "activateFailed": "Activate failed",
    "failedToLoadWeekPatterns": "Failed to load week patterns",
    "failedToLoadDevices": "Failed to load devices",
    "registrationFailed": "Registration failed",
    "failedToLoadHierarchy": "Failed to load hierarchy",
    "failedToLoadEmployeeDetails": "Failed to load employee details",
    "lifecycleUpdateFailed": "Lifecycle update failed",
    "yourEmployeeProfileIsNotLinkedContactHr": "Your employee profile is not linked. Contact HR to link your account.",
    "leaveTypeAndAtLeastOneDayAre": "Leave type and at least one day are required",
    "leaveReasonIsRequired": "Leave reason is required",
    "failedToLoadEmployeeSelfServiceProfile": "Failed to load employee self-service profile",
    "failedToLoadScheduleAndTimeData": "Failed to load schedule and time data",
    "failedToLoadApprovalRequests": "Failed to load approval requests",
    "failedToLoadLeaveBalances": "Failed to load leave balances",
    "manualCheckOutFailed": "Manual check-out failed",
    "leaveApplicationFailed": "Leave application failed",
    "payslipDownloadFailed": "Payslip download failed",
    "launchFailed": "Launch failed",
    "failedToLoadSummary": "Failed to load summary",
    "dateAndNameAreRequired": "Date and name are required",
    "selectAHolidayTypeConfigureTypesOnThe": "Select a holiday type — configure types on the Holiday types tab first",
    "failedToLoadHolidays": "Failed to load holidays",
    "deleteFailed": "Delete failed",
    "selectAnEmployee": "Select an employee",
    "onboardingFailed": "Onboarding failed",
    "exitInitiationFailed": "Exit initiation failed",
    "exitFinalizeFailed": "Exit finalize failed",
    "employeeAndPrincipalAmountAreRequired": "Employee and principal amount are required",
    "failedToCreateLoanRequest": "Failed to create loan request",
    "failedToSaveLeaveType": "Failed to save leave type",
    "failedToSaveEmploymentType": "Failed to save employment type",
    "failedToSaveDocumentType": "Failed to save document type",
    "failedToSaveOvertimeType": "Failed to save overtime type",
    "failedToSaveShiftType": "Failed to save shift type",
    "failedToSaveExpenseType": "Failed to save expense type",
    "failedToSaveAssetType": "Failed to save asset type",
    "failedToSavePipelineStage": "Failed to save pipeline stage",
    "failedToLoadManagerDashboard": "Failed to load manager dashboard",
    "failedToLoadTeamHierarchy": "Failed to load team hierarchy",
    "youDoNotHavePermissionToChangeReporting": "You do not have permission to change reporting relationships",
    "employeeAndManagerMustBeDifferent": "Employee and manager must be different",
    "youDoNotHavePermissionToRemoveReporting": "You do not have permission to remove reporting relationships",
    "failedToLoadReportingHierarchy": "Failed to load reporting hierarchy",
    "dateHoursAndOvertimeTypeAreRequired": "Date, hours, and overtime type are required",
    "overtimeHoursMustBeGreaterThanZero": "Overtime hours must be greater than zero",
    "failedToLoadOvertimeRequests": "Failed to load overtime requests",
    "cancelFailed": "Cancel failed",
    "runCodeAndPeriodDatesAreRequired": "Run code and period dates are required",
    "failedToCreatePayrollRun": "Failed to create payroll run",
    "payrollCalculationFailedApproveTheRunFirst": "Payroll calculation failed — approve the run first",
    "statutoryExportFailed": "Statutory export failed",
    "failedToLoadTransactions": "Failed to load transactions",
    "disbursementExportFailed": "Disbursement export failed",
    "failedToScheduleInterview": "Failed to schedule interview",
    "failedToCompleteInterview": "Failed to complete interview",
    "failedToCreateOffer": "Failed to create offer",
    "assessmentFailed": "Assessment failed",
    "failedToAcceptOffer": "Failed to accept offer",
    "failedToDeclineOffer": "Failed to decline offer",
    "preboardingFailed": "Preboarding failed",
    "failedToApproveSelection": "Failed to approve selection",
    "failedToApproveOffer": "Failed to approve offer",
    "screeningFailed": "Screening failed",
    "probationConfirmationFailed": "Probation confirmation failed",
    "failedToExtendProbation": "Failed to extend probation",
    "bgvUpdateFailed": "BGV update failed",
    "failedToLoadWorkQueue": "Failed to load work queue",
    "failedToLoadPipeline": "Failed to load pipeline",
    "failedToLoadJobPostings": "Failed to load job postings",
    "failedToLoadRequisitions": "Failed to load requisitions",
    "failedToLoadManpowerRequests": "Failed to load manpower requests",
    "submitFailed": "Submit failed",
    "failedToCreateJobPosting": "Failed to create job posting",
    "failedToCreateRequisition": "Failed to create requisition",
    "failedToAddCandidate": "Failed to add candidate",
    "failedToCreateManpowerRequest": "Failed to create manpower request",
    "failedToLoadAnalytics": "Failed to load analytics",
    "exportFailed": "Export failed",
    "failedToLoadHrSetup": "Failed to load HR setup",
    "failedToLoadHiringPolicy": "Failed to load hiring policy",
    "failedToLoadApprovalPolicy": "Failed to load approval policy",
    "seedFailed": "Seed failed",
    "failedToSaveHiringPolicy": "Failed to save hiring policy",
    "failedToSaveApprovalPolicy": "Failed to save approval policy",
    "failedToSaveWorkforceSettings": "Failed to save workforce settings",
    "shiftNameAndTypeAreRequired": "Shift name and type are required",
    "failedToUpdateShift": "Failed to update shift",
    "shiftAndAtLeastOneDayAreRequired": "Shift and at least one day are required",
    "failedToLoadShiftAssignments": "Failed to load shift assignments",
    "failedToLoadShifts": "Failed to load shifts",
    "failedToLoadShiftChangeRequests": "Failed to load shift change requests",
    "failedToLoadShiftChangeHistory": "Failed to load shift change history",
    "downloadFailed": "Download failed",
    "failedToLoadSuccessionPlans": "Failed to load succession plans",
    "createFailed": "Create failed",
    "updateFailed": "Update failed",
    "failedToLoadTrainingCourses": "Failed to load training courses",
    "createCourseFailed": "Create course failed",
    "assignFailed": "Assign failed",
    "failedToLoadTravelRequests": "Failed to load travel requests",
    "dateIsRequired": "Date is required",
    "failedToRemoveOverride": "Failed to remove override",
    "weeklyOtAggregationFailed": "Weekly OT aggregation failed",
    "companyWeeklyOtFailed": "Company weekly OT failed",
    "monthEndFailed": "Month-end failed",
    "portalFilingFailed": "{{portalCode}} filing failed",
    "failedToLoadEmploymentTypes": "Failed to load employment types",
    "failedToLoadExpenseTypes": "Failed to load expense types",
    "failedToLoadLeaveTypes": "Failed to load leave types",
    "failedToLoadOvertimeTypes": "Failed to load overtime types",
    "failedToLoadShiftTypes": "Failed to load shift types",
    "failedToLoadCourses": "Failed to load courses",
    "failedToLoadAssetRequests": "Failed to load asset requests",
    "failedToLoadExpenseClaims": "Failed to load expense claims",
    "failedToLoadEmployees": "Failed to load employees",
    "failedToLoadLoanRequests": "Failed to load loan requests",
    "failedToLoadPayrollRuns": "Failed to load payroll runs",
    "failedToLoadTimesheet": "Failed to load timesheet",
    "failedToLoadTimesheetSummary": "Failed to load timesheet summary",
    "failedToPreviewRosterCopy": "Failed to preview roster copy",
    "failedToCopyRoster": "Failed to copy roster",
    "failedToUpdateShiftDay": "Failed to update shift for this day",
    "failedToPublishRoster": "Failed to publish roster",
    "receiptRequiredForExpenseType": "A receipt is required for this expense type.",
    "enterSettlementAmount": "Enter a settlement amount."
  },
  "pages": {
    "hrAdmin": "HR admin",
    "fieldPermissionsCountryPacksShiftRotation": "Field permissions, country packs, shift rotation patterns",
    "noFieldPermissions": "No field permissions",
    "noCountryPacks": "No country packs",
    "noShiftRotations": "No shift rotations",
    "performanceAppraisal": "Performance appraisal",
    "cyclesSelfManagerHrReviewsAnd": "Cycles, self/manager/HR reviews, and final ratings",
    "assetRequests": "Asset requests",
    "employeeAssetRequestsWithApprovalWorkflow": "Employee asset requests with approval workflow",
    "newAssetRequest": "New asset request",
    "submitAssetRequest": "Submit request",
    "expenseClaims": "Expense claims",
    "approvedClaimsLoaded": "Approved claims (loaded)",
    "pendingClaimsLoaded": "Pending claims (loaded)",
    "reimbursementsWithApprovalWorkflowAndFinance": "Reimbursements with approval workflow and finance integration",
    "compensation": "Compensation",
    "salaryStructuresAndEmployeeAssignments": "Salary structures and employee assignments",
    "noStructuresYet": "No structures yet",
    "noAssignmentsForThisEmployeeYet": "No assignments for this employee yet",
    "selectAnEmployee": "Select an employee",
    "expectedHours": "Expected hours",
    "workedHoursApproved": "Worked hours (approved)",
    "overtimeApproved": "Overtime (approved)",
    "employmentType": "Employment type",
    "employmentSummary": "Employment summary",
    "recentAttendance": "Recent attendance",
    "recentLeave": "Recent leave",
    "recentExpenses": "Recent expenses",
    "employmentDetails": "Employment details",
    "lifecycleHistory": "Lifecycle history",
    "employmentHistory": "Employment history",
    "attendanceHistory": "Attendance history",
    "leaveHistory": "Leave history",
    "payrollRuns": "Payroll runs",
    "bankDetails": "Bank details",
    "performanceReviews": "Performance reviews",
    "employeeDocuments": "Employee documents",
    "training": "Training",
    "assignedAssets": "Assigned assets",
    "chooseSomeoneFromTheDirectoryOr": "Choose someone from the directory or hierarchy to view their full HR profile.",
    "lastRecordedDays": "Last recorded days",
    "latestLeaveRequests": "Latest leave requests",
    "stageChangesAndHrEvents": "Stage changes and HR events",
    "noAttendanceRecords": "No attendance records",
    "noLeaveRecords": "No leave records",
    "noExpenseClaims": "No expense claims",
    "noPayrollRecords": "No payroll records",
    "noPerformanceReviews": "No performance reviews",
    "attendanceWillAppearHereOnceRecorded": "Attendance will appear here once recorded.",
    "leaveRequestsWillAppearHereOnce": "Leave requests will appear here once submitted.",
    "documentPreview": "Document preview",
    "editEmployment": "Edit employment",
    "assignDepartmentDesignationGradeAndBusiness": "Assign department, designation, grade, and business unit from your company master data. Create masters under HR → Master data if lists are empty.",
    "goToToday": "Go to today",
    "noHolidayTypesYet": "No holiday types yet",
    "workforceDetails": "Workforce details",
    "candidates": "Candidates",
    "leave": "Leave %",
    "attendanceRecords": "Attendance records",
    "workforceTimePayAndTalentScoped": "Workforce, time, pay, and talent — scoped to your role and reporting tree",
    "attendanceDevices": "Attendance devices",
    "biometricRfidQrAndFaceRecognition": "Biometric, RFID, QR, and face recognition connectors",
    "employeeDirectory": "Employee directory",
    "browseEmployeesExploreReportingHierarchyAnd": "Browse employees, explore reporting hierarchy, and manage profiles including documents",
    "employmentAtAGlance": "Employment at a glance",
    "leaveBalances": "Leave balances",
    "upcomingRoster": "Upcoming roster",
    "recentRoster": "Recent roster",
    "yourRecordsAtAGlance": "Your records at a glance",
    "attendance": "Attendance",
    "leaveRequests": "Leave requests",
    "payslips": "Payslips",
    "myApprovalRequests": "My approval requests",
    "overtime": "Overtime",
    "availableDaysByLeaveType": "Available days by leave type",
    "yourNextScheduledShiftsFromToday": "Your next scheduled shifts from today",
    "lastRosterEntriesForThisMonth": "Last roster entries for this month",
    "last5EntriesInEachArea": "Last 5 entries in each area — everything in one place",
    "recentCheckInsAndHours": "Recent check-ins and hours",
    "recentApplicationsAndStatus": "Recent applications and status",
    "recentPayrollRuns": "Recent payroll runs",
    "workflowStatusForYourSubmissions": "Workflow status for your submissions",
    "recentOvertimeRequests": "Recent overtime requests",
    "recentReimbursements": "Recent reimbursements",
    "assignedCourses": "Assigned courses",
    "applyForLeave": "Apply for leave",
    "availableLeave": "Available leave",
    "expectedMonth": "Expected (month)",
    "workedApproved": "Worked (approved)",
    "yourLeaveBalances": "Your leave balances",
    "noLeaveBalancesConfiguredForYourAccount": "No leave balances configured for your account.",
    "availableDaysReflectApprovedLeaveUsageOnly": "Available days reflect approved leave usage only. Pending requests are shown separately and do not reduce available until approved.",
    "yourProfileScheduleTimeLeavePay": "Your profile, schedule, time, leave, pay, and HR support in one place",
    "trackLeaveAndOtherHrRequests": "Track leave and other HR requests submitted for approval.",
    "downloadPdfPayslipsForProcessedPayroll": "Download PDF payslips for processed payroll runs.",
    "noLeaveHistory": "No leave history",
    "noPayslipsAvailable": "No payslips available",
    "submittedLeaveRequestsWillAppearHere": "Submitted leave requests will appear here.",
    "payslipsAppearAfterPayrollIsProcessed": "Payslips appear after payroll is processed.",
    "employment": "Employment",
    "bankDetailsForPayroll": "Bank details for payroll",
    "requiredDocumentTracking": "Required document tracking",
    "documents": "Documents",
    "assets": "Assets",
    "leaveSummary": "Leave summary",
    "recentAttendanceOvertime": "Recent attendance overtime",
    "typesConfiguredWithExpiryTracking": "Types configured with expiry tracking",
    "viewUploadAndDownloadYourHr": "View, upload, and download your HR documents",
    "companyAssetsAssignedToYou": "Company assets assigned to you",
    "noTrackedDocumentTypesConfigured": "No tracked document types configured",
    "noTrainingAssigned": "No training assigned",
    "noAssetsAssigned": "No assets assigned",
    "noReviewsYet": "No reviews yet",
    "noOvertimeFromAttendance": "No overtime from attendance",
    "workScheduleOverview": "Work schedule overview",
    "shiftAssignments": "Shift assignments",
    "roster": "Roster",
    "workCalendar": "Work calendar",
    "yourAssignedShiftsAndEffectivePeriods": "Your assigned shifts and effective periods",
    "daySpecificShiftOverridesForThis": "Day-specific shift overrides for this month",
    "resolvedScheduleIncludingHolidaysAndShift": "Resolved schedule including holidays and shift times",
    "noShiftAssignment": "No shift assignment",
    "noRosterEntriesThisMonth": "No roster entries this month",
    "yourHrTeamAssignsShiftsUnder": "Your HR team assigns shifts under Shifts. Company default calendar applies when none is set.",
    "rosterEntriesAppearWhenYourManager": "Roster entries appear when your manager plans a specific shift for a date.",
    "timeSummary": "Time summary",
    "expected": "Expected",
    "missing": "Missing",
    "overtimeRequests": "Overtime requests",
    "thisMonthAtAGlance": "This month at a glance",
    "manualOvertimeRequestsSubmittedForApproval": "Manual overtime requests submitted for approval",
    "noOvertimeRequestsThisMonth": "No overtime requests this month",
    "yourCheckInsAndAttendanceWill": "Your check-ins and attendance will appear here.",
    "overtimeFromAttendanceIsCalculatedAutomatically": "Overtime from attendance is calculated automatically when you check out.",
    "peerManagerAndSubordinateFeedbackCycles": "Peer, manager, and subordinate feedback cycles",
    "noFeedbackResponsesYet": "No feedback responses yet",
    "publicHolidays": "Public holidays",
    "companyCalendarDaysAndCustomizableHoliday": "Company calendar days and customizable holiday categories for attendance, leave, and schedules",
    "noHolidaysForThisYear": "No holidays for this year",
    "addHolidaysSoLeaveAndAttendance": "Add holidays so leave and attendance respect your company calendar.",
    "onboardingExit": "Onboarding & exit",
    "preboardingTasksAndSeparationWorkflow": "Preboarding tasks and separation workflow",
    "employeeLoans": "Employee loans",
    "loanRequestsWithPlatformApprovalWorkflow": "Loan requests with platform approval workflow",
    "addALeaveTypeFirstThen": "Add a leave type first, then configure policies for paid leave types",
    "noLeaveTypesYetAddYour": "No leave types yet — add your own",
    "noEmploymentTypesAddFullTime": "No employment types — add Full-time, Contract, Intern, etc.",
    "noDocumentTypesAddPassportVisa": "No document types — add Passport, Visa, Contract, etc.",
    "noOvertimeTypesYetAddTypes": "No overtime types yet — add types for working day, holiday, weekend, etc.",
    "noShiftTypesYetAddFixed": "No shift types yet — add Fixed, Flexible, Rotational, or your own categories",
    "noPipelineStagesDefaultsAreCreated": "No pipeline stages — defaults are created on first load",
    "noExpenseTypesYetAddTravel": "No expense types yet — add Travel, Meals, Supplies, etc.",
    "noAssetTypesYetAddLaptop": "No asset types yet — add Laptop, Phone, Monitor, etc.",
    "noBusinessUnitsYetAddYour": "No business units yet — add your company divisions",
    "noDepartmentsYetCreateTeamsEmployees": "No departments yet — create teams employees can be assigned to",
    "noGradesYetDefineJobLevels": "No grades yet — define job levels (e.g. G1, G2, Senior)",
    "noDesignationsYetAddJobTitles": "No designations yet — add job titles and link them to grades",
    "yourTeamHierarchyPendingApprovalsAnd": "Your team hierarchy, pending approvals, and quick actions",
    "reportingHierarchy": "Reporting hierarchy",
    "viewAndManageWhoReportsTo": "View and manage who reports to whom. Departments, designations, grades, and business units are configured in HR master data.",
    "noOvertimeRequestsInThisPeriod": "No overtime requests in this period",
    "countryTemplatesSalaryCalculationAndFinance": "Country templates, salary calculation, and finance GL integration",
    "assessments": "Assessments",
    "backgroundVerification": "Background verification",
    "probationReview": "Probation review",
    "stageHistory": "Stage history",
    "scheduleInterview": "Schedule interview",
    "completeInterview": "Complete interview",
    "createOfferLetter": "Create offer letter",
    "scheduleAssessment": "Schedule assessment",
    "declineOffer": "Decline offer?",
    "recruitment": "Recruitment",
    "openPositions": "Open positions",
    "candidatesInPipeline": "Candidates in pipeline",
    "interviewsScheduled": "Interviews scheduled",
    "offersPending": "Offers pending",
    "preboarding": "Preboarding",
    "onboarding": "Onboarding",
    "joiningThisMonth": "Joining this month",
    "pendingRequisitions": "Pending requisitions",
    "pendingManpower": "Pending manpower",
    "probationPending": "Probation pending",
    "avgTimeToHireDays": "Avg time to hire (days)",
    "avgTimeToFillDays": "Avg time to fill (days)",
    "offerAcceptance": "Offer acceptance %",
    "joiningRatio": "Joining ratio %",
    "onboardingCompletion": "Onboarding completion %",
    "probationSuccess": "Probation success %",
    "totalHired": "Total hired",
    "totalApplied": "Total applied",
    "pendingInterviews": "Pending interviews",
    "pendingFeedback": "Pending feedback",
    "pendingOffers": "Pending offers",
    "pendingPreboarding": "Pending preboarding",
    "pendingOnboarding": "Pending onboarding",
    "pendingBgv": "Pending BGV",
    "pendingConfirmations": "Pending confirmations",
    "searchCandidates": "Search candidates",
    "newRequisition": "New requisition",
    "newJobPosting": "New job posting",
    "addCandidate": "Add candidate",
    "newManpowerRequest": "New manpower request",
    "requisitionPostingPipelineOfferOnboardingEmployee": "Requisition → posting → pipeline → offer → onboarding → employee",
    "noManpowerRequestsCreateOneTo": "No manpower requests — create one to plan headcount",
    "noRequisitionsCreateAPositionRequisition": "No requisitions — create a position requisition to start hiring",
    "noJobPostingsApproveARequisition": "No job postings — approve a requisition and post a job",
    "hrReports": "HR reports",
    "headcount": "Headcount",
    "attendance2": "Attendance %",
    "pendingLeaves": "Pending leaves",
    "workforceAnalyticsAndStatutoryExports": "Workforce analytics and statutory exports",
    "generalHrSettings": "General HR settings",
    "companyPoliciesForHiringLeaveAttendance": "Company policies for hiring, leave, attendance, approvals, date & time display, and default HR seed data.",
    "noSetupDataYetSeedDefaults": "No setup data yet — seed defaults to populate",
    "editShift": "Edit shift",
    "shifts": "Shifts",
    "timesheet": "Timesheet",
    "assignShift": "Assign shift",
    "noShiftAssignments": "No shift assignments",
    "approvedAssignmentsAndPendingShiftChanges": "Approved assignments and pending shift changes appear here after you submit them.",
    "statutoryFiling": "Statutory filing",
    "automatedPortalSubmissionEpfoEcrEsic": "Automated portal submission (EPFO ECR, ESIC, TRACES) plus manual portal links",
    "successionPlanning": "Succession planning",
    "criticalPositionsSuccessorsAndRiskAnalysis": "Critical positions, successors, and risk analysis",
    "noSuccessionPlansYet": "No succession plans yet",
    "coursesAssignmentsAndCompletionTracking": "Courses, assignments, and completion tracking",
    "travelManagement": "Travel management",
    "travelRequestsApprovalAndSettlement": "Travel requests, approval, and settlement",
    "newTravelRequest": "New travel request",
    "workCalendarsSchedules": "Work calendars & schedules",
    "worked": "Worked",
    "dailyOt": "Daily OT",
    "weeklyOt": "Weekly OT",
    "chooseAnEmployeeToViewTheir": "Choose an employee to view their resolved work calendar, overrides, and weekly overtime for the selected month.",
    "noOverridesThisMonth": "No overrides this month",
    "noWeeklySummariesForThisMonth": "No weekly summaries for this month",
    "useTheFormAboveOrSwitch": "Use the form above or switch to calendar view and click a day to add an override.",
    "recalculateTheCurrentWeekOrWait": "Recalculate the current week or wait for the Sunday scheduler."
  },
  "labels": {
    "reviewer": "Reviewer",
    "score": "Score",
    "comments": "Comments",
    "newCycleName": "New cycle name",
    "fullName": "Full name",
    "email": "Email",
    "phone": "Phone",
    "structureName": "Structure name",
    "salaryStructure": "Salary structure",
    "grossAmount": "Gross amount",
    "effectiveFrom": "Effective from",
    "effectiveTo": "Effective to",
    "selectStructure": "Select structure",
    "selectOvertimeType": "Select overtime type",
    "overtimeType": "Overtime type",
    "calendarGranularity": "Calendar granularity",
    "loadingSchedule": "Loading schedule",
    "loadingCalendar": "Loading calendar",
    "documentName": "Document name",
    "documentIdNumber": "Document ID / number",
    "issueDate": "Issue date",
    "expiryDate": "Expiry date",
    "expiryDateOptional": "Expiry date (optional)",
    "documentFile": "Document file",
    "eGPassportEmiratesId": "e.g. Passport, Emirates ID",
    "enterTheIdShownOnThe": "Enter the ID shown on the document",
    "chooseADocumentToUpload": "Choose a document to upload",
    "bankName": "Bank name",
    "branch": "Branch",
    "accountNumber": "Account number",
    "ifscRoutingCode": "IFSC / routing code",
    "bank": "Bank",
    "account": "Account",
    "ifscRouting": "IFSC / routing",
    "optional": "Optional",
    "department": "Department",
    "designation": "Designation",
    "grade": "Grade",
    "businessUnit": "Business unit",
    "anyDepartment": "Any department",
    "anyDesignation": "Any designation",
    "anyGrade": "Any grade",
    "anyUnit": "Any unit",
    "manager": "Manager",
    "loadingEmployeeProfile": "Loading employee profile",
    "employmentType": "Employment type",
    "assetType": "Asset type",
    "lifecycleEvents": "Lifecycle events",
    "eventType": "Event type",
    "effectiveDate": "Effective date",
    "allDepartments": "All departments",
    "allDesignations": "All designations",
    "allGrades": "All grades",
    "allBusinessUnits": "All business units",
    "employeeReportingHierarchy": "Employee reporting hierarchy",
    "code": "Code",
    "name": "Name",
    "description": "Description",
    "nonWorkingDay": "Non-working day",
    "eGPub": "e.g. PUB",
    "displayName": "Display name",
    "noFileChosen": "No file chosen",
    "profileSections": "Profile sections",
    "timeDisplayUnit": "Time display unit",
    "defaultStart": "Default start",
    "defaultEnd": "Default end",
    "eGMf9": "e.g. MF9",
    "mondayFriday": "Monday – Friday",
    "allStatuses": "All statuses",
    "allTypes": "All types",
    "deviceName": "Device name",
    "deviceCode": "Device code",
    "employeeDirectoryNavigation": "Employee directory navigation",
    "searchEmployees": "Reporting members",
    "employees": "Employees",
    "loadingHierarchy": "Loading hierarchy",
    "employeeProfileDetails": "Employee profile details",
    "nameCodeOrEmail": "Name, code, or email",
    "lifecycle": "Lifecycle",
    "currentShift": "Current shift",
    "leaveDays": "Leave days",
    "loadingSelfServicePortal": "Loading self-service portal",
    "refreshPortalData": "Refresh portal data",
    "employeeCode": "Employee code",
    "reviewee": "Reviewee",
    "cycleId": "Cycle ID",
    "year": "Year",
    "date": "Date",
    "type": "Type",
    "selectType": "Select type",
    "reason": "Reason",
    "leaveType": "Leave type",
    "policyName": "Policy name",
    "accrual": "Accrual",
    "daysPerPeriod": "Days per period",
    "annualEntitlement": "Annual entitlement",
    "maxConsecutiveDays": "Max consecutive days",
    "maxCarryForward": "Max carry forward",
    "allowBackdatedLeave": "Allow backdated leave",
    "maxBackdatedDays": "Max backdated days",
    "policyActive": "Policy active",
    "paidLeave": "Paid leave",
    "carryForward": "Carry forward",
    "leaveTypeColor": "Leave type color",
    "payrollMode": "Payroll mode",
    "defaultHoursDay": "Default hours/day",
    "requiresEndDate": "Requires end date",
    "requiresReturnOnExit": "Requires return on exit",
    "trackExpiryDate": "Track expiry date",
    "applicableDay": "Applicable day",
    "receiptRequired": "Receipt required",
    "returnRequired": "Return required",
    "stageColor": "Stage color",
    "eGAnl": "e.g. ANL",
    "eGFtm": "e.g. FTM",
    "eGPas": "e.g. PAS",
    "eGWot": "e.g. WOT",
    "eGFix": "e.g. FIX",
    "eGTrv": "e.g. TRV",
    "eGPhoneScreen": "e.g. Phone screen",
    "eGScr": "e.g. SCR",
    "levelOrder": "Level order",
    "descriptionOptional": "Description (optional)",
    "businessUnitOptional": "Business unit (optional)",
    "parentDepartmentOptional": "Parent department (optional)",
    "departmentOptional": "Department (optional)",
    "gradeOptional": "Grade (optional)",
    "noBusinessUnit": "No business unit",
    "noParent": "No parent",
    "noDepartment": "No department",
    "noGrade": "No grade",
    "shiftColor": "Shift color",
    "employee": "Employee",
    "hours": "Hours",
    "from": "From",
    "to": "To",
    "runCode": "Run code",
    "countryFormulas": "Country (formulas)",
    "round": "Round",
    "dateTime": "Date & time",
    "score15": "Score (1–5)",
    "feedback": "Feedback",
    "salary": "Salary",
    "joiningDate": "Joining date",
    "offerMessage": "Offer message",
    "positionTitle": "Position title",
    "location": "Location",
    "numberOfPositions": "Number of positions",
    "jobTitle": "Job title",
    "positions": "Positions",
    "jobPosting": "Job posting",
    "source": "Source",
    "title": "Title",
    "requestType": "Request type",
    "nameOrEmail": "Name or email…",
    "eGSalesExecutive": "e.g. Sales Executive",
    "eGChennai": "e.g. Chennai",
    "selectJob": "Select job",
    "eGQ3EngineeringHires": "e.g. Q3 engineering hires",
    "defaultApprovalMode": "Default approval mode",
    "hrManagersMayAutoApproveLeave": "HR managers may auto-approve leave filed on behalf of others",
    "newHirePath": "New hire path",
    "fullDay": "Full day",
    "halfDay": "Half day",
    "hourly": "Hourly",
    "maxHourlyLeaveDay": "Max hourly leave / day",
    "multiShiftPerDay": "Multi-shift per day",
    "maxShiftsPerDay": "Max shifts per day",
    "strictPresentAllShifts": "Strict present (all shifts)",
    "defaultTimeDisplay": "Default time display",
    "defaultCalendarView": "Default calendar view",
    "shiftName": "Shift name",
    "startTime": "Start time",
    "endTime": "End time",
    "shiftDays": "Shift days",
    "criticalPosition": "Critical position",
    "incumbentEmployee": "Incumbent employee",
    "applyOverrideToEmployees": "Apply override to employees",
    "dayType": "Day type",
    "startOptional": "Start (optional)",
    "endOptional": "End (optional)",
    "purpose": "Purpose",
    "supportingDocumentOptional": "Supporting document (optional)"
  },
  "lifecycleEvents": {
    "confirmed": "Confirmed",
    "promotion": "Promotion",
    "transfer": "Transfer",
    "probation": "Probation",
    "termination": "Termination",
    "resignation": "Resignation"
  },
  "formActions": {
    "saveOverride": "Save override",
    "savePolicy": "Save policy",
    "removeManager": "Remove manager",
    "saveReportingLine": "Save reporting line",
    "requestOvertime": "Request overtime",
    "createRequisition": "Create requisition",
    "createPosting": "Create posting",
    "addCandidate": "Add candidate",
    "createManpowerRequest": "Create request",
    "markSelected": "Mark selected",
    "createAndSendOffer": "Create & send offer",
    "scheduleAndComplete": "Schedule & complete",
    "saveChanges": "Save changes",
    "addHoliday": "Add holiday",
    "addType": "Add type",
    "updatePattern": "Update pattern",
    "createPattern": "Create pattern",
    "saveApprovalPolicy": "Save approval policy",
    "saveHiringPolicy": "Save hiring policy"
  },
  "setupPage": {
    "seedDefaults": "Seed defaults",
    "snapshotTitle": "Setup snapshot",
    "approvalPolicyTitle": "Approval workflow policy",
    "approvalPolicyDescription": "Per-company governance for leave, attendance, procurement, finance, and other approvals",
    "perModuleOverrides": "Per-module overrides",
    "perModuleOverridesHint": "Override the company default for specific modules. When not set to Yes, the default mode above applies.",
    "onBehalfAutoApproveHint": "When enabled, users with HR leave manage permission can submit leave for another employee and it is approved immediately without a workflow instance.",
    "hiringPolicyTitle": "Hiring policy",
    "hiringPolicyDescription": "Control whether new employees must come through recruitment or can be added directly",
    "forCompany": " for {{company}}",
    "companySuffix": " — {{company}}",
    "hiringModes": {
      "recruitment": {
        "label": "Recruitment only (recommended)",
        "description": "New hires must go through HR → Recruitment → Hire. Blocks direct Add employee."
      },
      "direct": {
        "label": "Allow direct employee creation",
        "description": "HR can add employees from Administration → Employees without the ATS workflow."
      }
    },
    "workflowModes": {
      "flexible": {
        "label": "Flexible (recommended)",
        "description": "Leave, attendance, procurement, and finance submissions work immediately. Approval buttons appear only when you configure workflows in Approvals."
      },
      "strict": {
        "label": "Require configured workflows",
        "description": "Submissions are blocked until an approval workflow is configured for that module. Use when governance must be enforced."
      }
    },
    "modules": {
      "HR": "HR (leave, attendance, payroll, …)",
      "PROCUREMENT": "Procurement",
      "FINANCE": "Finance",
      "INVENTORY": "Inventory",
      "CRM": "CRM",
      "DESK": "Desk",
      "POS": "POS",
      "WAREHOUSE": "Warehouse"
    },
    "workforce": {
      "loading": "Loading leave and attendance settings…",
      "savedToast": "Leave and attendance settings saved",
      "leaveModesTitle": "Leave request modes",
      "leaveModesDescription": "Configure leave duration types and shift attendance rules",
      "leaveSection": "Leave",
      "leaveSectionHint": "Which leave duration types employees can request and hourly limits.",
      "shiftSection": "Shift",
      "shiftSectionHint": "Multi-shift attendance and how present status is evaluated across shifts.",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "multiShiftDisabled": "Disabled (single shift)",
      "anyShiftPresent": "Any shift present",
      "allShiftsRequired": "All shifts required",
      "mobileAttendanceTitle": "Mobile & geo attendance",
      "mobileAttendanceHint": "Control device binding and geo-fence enforcement for employee self-service check-in.",
      "requireMobileBinding": "Require mobile device binding",
      "requireGeoAttendance": "Require geo attendance",
      "strictGeoFence": "Strict geo-fence",
      "strictGeoBlock": "Block outside fence",
      "strictGeoFlag": "Allow but flag",
      "calendarDefaultsTitle": "Attendance calendar defaults",
      "calendarDefaultsDescription": "Default time units and calendar zoom when users open Attendance. Individuals can still switch views during their session.",
      "saveLeaveModes": "Save leave request modes",
      "saveMobileAttendance": "Save mobile & geo attendance",
      "saveCalendarDefaults": "Save calendar defaults",
      "leaveModesSavedToast": "Leave request modes saved",
      "mobileAttendanceSavedToast": "Mobile & geo attendance settings saved",
      "calendarDefaultsSavedToast": "Attendance calendar defaults saved",
      "saveSettings": "Save leave & attendance settings",
      "laborRulesTitle": "Time, overtime & payroll rules",
      "laborRulesDescription": "Turn on advanced rules for overtime limits, compensatory rest banks (RCR/RCO), holiday premiums, meal allowances, and frozen timesheet snapshots at month-end.",
      "saveLaborRules": "Save labor rules",
      "laborRulesSavedToast": "Labor rules saved",
      "laborRules": {
        "enabled": "Enable labor rules",
        "enabledLabel": "Use advanced time & payroll rules for this company",
        "enabledHint": "When enabled, timesheets apply holiday premiums, paid-leave-as-worked, overtime contingent tracking, and comp-rest accrual according to the settings below. Allowances are configured under Compensation & Benefits.",
        "contingentHours": "Annual OT contingent (hours)",
        "contingentWarningPercent": "Contingent warning (%)",
        "rcrMode": "RCR accrual mode",
        "rcoMandatory": "RCO mandatory after contingent",
        "holidayPremiumRate": "Default holiday premium rate",
        "solidarityDay": "Solidarity day",
        "timesheetSnapshots": "Persist timesheet day snapshots on month-end",
        "rcrModes": {
          "payOnly": "Pay only",
          "replace": "Replace with RCR",
          "split": "Split pay and RCR"
        }
      }
    }
  },
  "shiftsPage": {
    "assignEmployeeHint": "Assign the same shift to one or more employees.",
    "selectDaysHint": "Click or drag across days to select. Only the days you pick apply to this shift.",
    "copySchedule": "Copy schedule",
    "copyScheduleTitle": "Copy schedule",
    "copyScheduleHint": "Choose what to copy and where to paste. Copied shifts appear on the calendar as a draft. Publish when the schedule is final.",
    "copySourceLabel": "Copy from",
    "copySourceVisibleWeek": "Visible week",
    "copySourceVisibleMonth": "Visible month",
    "copySourceSingleDay": "Single day",
    "copySourceWeekNumber": "Week number",
    "copySourceMonth": "Month",
    "copySourceCustomRange": "Custom date range",
    "copySourceDay": "Source day",
    "copyRangeFrom": "From",
    "copyRangeTo": "To",
    "copyWeekNumber": "Week number",
    "copyMonth": "Month",
    "copyYear": "Year",
    "copyTargetLabel": "Paste to",
    "copyTargetNextDay": "Next day (shift by 1 day)",
    "copyTargetNextWeek": "Next week (shift by 7 days)",
    "copyTargetNextMonth": "Next month (same dates +1 month)",
    "copyTargetSpecificDate": "Specific start date",
    "copyTargetStartDate": "Target start date",
    "copyTargetStartDateHint": "The first source day maps to this date. Example: copy 6 Jun to 8 Jun.",
    "copyTargetWeekNumber": "Target week number",
    "copyTargetMonth": "Target month",
    "copyRangePreview": "Copy {{sourceFrom}} → {{sourceTo}} to start at {{targetFrom}}",
    "copyTargetMode_NEXT_DAY": "next day",
    "copyTargetMode_NEXT_WEEK": "next week",
    "copyTargetMode_NEXT_MONTH": "next month",
    "copyTargetMode_CUSTOM": "custom date",
    "copyToNextWeek": "Copy to next week",
    "copyWeekTitle": "Employees",
    "copyWeekHint": "Copy the visible week's schedule forward by one week.",
    "copyWeekScopeAll": "All employees with shifts in source range",
    "copyWeekScopeSelected": "Selected employees only",
    "copyWeekSelectEmployees": "Employees to copy",
    "copyWeekEmployeesRequired": "Select at least one employee",
    "copyWeekEmployeesHint": "Only employees with shifts in the source range are copied.",
    "copyPreviewTitle": "Confirm schedule copy",
    "copyPreviewSummary": "{{count}} assignment(s) will be copied. {{conflicts}} conflict(s) detected.",
    "copyNothingToStage": "No shifts found to copy for the selected range.",
    "draftSchedule": "Draft (not published)",
    "editDraftShift": "Edit this day (draft)",
    "editDraftShiftHint": "Changes save immediately. Publish when the schedule is final.",
    "clearDraftShift": "Clear day",
    "publish": "Publish",
    "expectedColumn": "Expected",
    "calendarHint": "Click a day to view shift details, edit draft shifts, pending approvals, or assign a new shift. After copying a schedule, review the draft week and use Publish to save it.",
    "noEmployeesInScope": "No employees in your visibility scope."
  },
  "timesheetPage": {
    "title": "Timesheet",
    "description": "Monthly worked hours, leave, absences, and payroll-ready buckets per employee.",
    "selectEmployeeHint": "Select an employee to view their timesheet.",
    "summary": {
      "worked": "Worked hours",
      "effective": "Effective worked",
      "overtime": "Overtime",
      "absenceDays": "Absence days",
      "paidLeaveWorked": "Paid leave as worked",
      "manual": "Manual attendance",
      "holidayPremium": "Holiday premium"
    },
    "badges": {
      "leave": "Leave",
      "absence": "Absence",
      "manual": "Manual",
      "solidarity": "Solidarity"
    },
    "tooltip": {
      "worked": "Worked {{value}}",
      "expected": "Expected {{value}}",
      "leave": "Leave: {{type}}",
      "absence": "Absence: {{code}}",
      "manual": "Manual attendance",
      "holidayWorked": "Holiday worked",
      "solidarity": "Solidarity day",
      "premium": "Premium {{value}}"
    }
  },
  "workforcePage": {
    "tabs": {
      "employee": "Employee schedule",
      "company": "Company templates & batch"
    },
    "dayTypes": {
      "WORKING": "Working day",
      "WEEKEND": "Weekend",
      "HOLIDAY": "Holiday",
      "HALF_DAY": "Half day",
      "SPECIAL": "Special day"
    },
    "toast": {
      "overrideSaved": "Calendar override saved"
    },
    "empty": {
      "selectEmployeeForOverride": "Select an employee to view or pick employees for bulk override"
    },
    "bulkOverrideHint": "Leave empty to apply only to the employee selected above. Select multiple for bulk override.",
    "employeeSchedule": "Employee schedule",
    "shiftSummary": "Shift: {{shift}} · {{days}} working days · {{hours}}/day",
    "defaultPattern": "Default pattern",
    "workCalendarHint": "Click a day to edit. Overrides take precedence over company calendar and holidays.",
    "weeklyOvertime": "Weekly overtime",
    "recalculateCurrentWeek": "Recalculate current week",
    "weekPatternTemplates": "Week pattern templates",
    "weekPatternTemplatesHint": "Reusable working-week templates for the active company. Assign a pattern under Org → Companies → Calendar tab.",
    "batchOperations": "Batch operations",
    "batchOperationsHint": "Run company-wide processes. Month-end feeds payroll and attendance summaries for the current month.",
    "runMonthEnd": "Run month-end"
  },
  "holidaysPage": {
    "companyWorkCalendar": "Company work calendar",
    "infoBanner": "Holidays apply to the <strong>active company</strong> in the header switcher. Configure weekly working days under Administration → Companies → Calendar. Define your own holiday types on the <strong>Holiday types</strong> tab (or per company in the company calendar dialog).",
    "laborRulesHint": "Timesheet treatment and premium rate apply when advanced labor rules are enabled (HR Setup → Workforce policy). Set a holiday to Worked holiday if employees may work that day and earn a premium; set Solidarity day for solidarity-day tracking.",
    "tabs": {
      "calendar": "Holiday calendar",
      "types": "Holiday types"
    },
    "holidayCount": "{{count}} holiday(s) in {{year}}",
    "noTypesWarning": "No active holiday types for this company.",
    "addTypesLink": "Add holiday types",
    "addTypesSuffix": "before creating calendar entries.",
    "editHoliday": "Edit holiday",
    "addHoliday": "Add holiday",
    "editHolidayType": "Edit holiday type",
    "addHolidayType": "Add holiday type",
    "nonWorkingYes": "Yes — full day off (holiday)",
    "nonWorkingNo": "No — special day (optional observance)",
    "cancelEdit": "Cancel edit",
    "typesDescription": "Define the holiday categories your company uses (e.g. public, regional, optional). When adding a holiday on the calendar tab, pick one of these types. Deactivate types you do not need instead of deleting them.",
    "treatmentLabel": "Timesheet treatment",
    "premiumRateLabel": "Premium rate (optional)",
    "premiumRatePlaceholder": "e.g. 1.5 — uses company default if empty",
    "columns": {
      "treatment": "Treatment",
      "premiumRate": "Premium rate"
    },
    "treatment": {
      "off": "Non-working holiday",
      "worked": "Worked holiday (premium if attended)",
      "solidarity": "Solidarity day"
    }
  },
  "leaveBehavior": {
    "title": "Timesheet & payroll behavior",
    "description": "How this leave type affects worked hours, scheduling, meal allowances, and compensatory rest banks.",
    "countsAsWorkedHours": "Counts as worked hours",
    "countsAsWorkedHoursHint": "Paid leave minutes count toward effective worked time on the timesheet.",
    "countsTowardOvertimeThreshold": "Counts toward overtime threshold",
    "generatesMealAllowance": "Generates meal allowance",
    "deductsFromLeaveBalance": "Deducts from leave balance",
    "blocksScheduling": "Blocks shift scheduling",
    "requiresDocument": "Requires supporting document",
    "isCompensatoryRest": "Compensatory rest leave",
    "isCompensatoryRestHint": "When approved, debits the selected RCR or RCO bank.",
    "restBankType": "Rest bank to debit",
    "restBankPlaceholder": "Select bank",
    "restBank": {
      "rcr": "RCR — compensatory rest",
      "rco": "RCO — over-contingent rest"
    },
    "premiumPayEligible": "Eligible for premium pay"
  },
  "compRest": {
    "title": "Compensatory rest balances",
    "description": "RCR and RCO hour banks for {{year}}. Accruals come from approved overtime; consumption from compensatory rest leave.",
    "rcrBalance": "RCR balance",
    "rcoBalance": "RCO balance",
    "noTransactions": "No comp-rest movements yet",
    "noTransactionsHint": "Approve overtime (with RCR accrual enabled) or take compensatory rest leave to see activity here.",
    "columns": {
      "date": "Date",
      "bank": "Bank",
      "type": "Type",
      "change": "Change",
      "balance": "Balance",
      "reason": "Reason"
    },
    "errors": {
      "loadFailed": "Failed to load compensatory rest balances"
    }
  },
  "adminPage": {
    "fieldPermissions": "Field permissions",
    "countryPacks": "Country packs",
    "shiftRotations": "Shift rotations"
  },
  "weekPatterns": {
    "description": "Create company-specific week patterns. Assign one to the work calendar — no fixed presets required.",
    "editTitle": "Edit week pattern",
    "newTitle": "New week pattern",
    "daysHeading": "Days (1 = Monday)",
    "applyDefaults": "Apply default times to working days",
    "savedPatterns": "Saved patterns",
    "columns": {
      "day": "Day",
      "working": "Working",
      "halfDay": "Half day",
      "start": "Start",
      "end": "End"
    },
    "weekdays": {
      "1": "Monday",
      "2": "Tuesday",
      "3": "Wednesday",
      "4": "Thursday",
      "5": "Friday",
      "6": "Saturday",
      "7": "Sunday"
    }
  },
  "workflowStatus": {
    "pending": "Pending approval",
    "approved": "Approved",
    "rejected": "Rejected",
    "returned": "Returned for changes"
  },
  "approvalRow": {
    "cancellationPending": "Cancellation pending approval",
    "cancellationPendingShort": "cancellation pending",
    "hideEdit": "Hide edit",
    "hideApproval": "Hide approval",
    "approvalAndHistory": "Approval & history"
  },
  "listActions": {
    "submit": "Submit",
    "postJob": "Post job",
    "scheduleInterview": "Schedule interview",
    "createOffer": "Create offer",
    "createCycle": "Create cycle",
    "createPlan": "Create plan",
    "createStructure": "Create structure",
    "assignSalary": "Assign salary",
    "submitRequest": "Submit request",
    "startOnboarding": "Start onboarding",
    "initiateExit": "Initiate exit",
    "finalizeExit": "Finalize exit",
    "launch360": "Launch 360",
    "viewSummary": "View summary",
    "registerDevice": "Register device",
    "submitApplication": "Submit application",
    "settle": "Settle",
    "cancel": "Cancel"
  },
  "messages": {
    "uploadTravelSupportingFile": "Upload travel itinerary, invitation letter, or other supporting file."
  },
  "reports": {
    "filterTitle": "Report period",
    "dateRangeInvalid": "Start date must be on or before end date",
    "dualSheetHint": "Excel exports include detailed rows and a per-employee summary (hours and days). Select an employee for their overall week or month report. Data respects your hierarchy visibility.",
    "workforceSection": "Workforce reports",
    "otherSection": "Other reports",
    "allRecords": "All records",
    "allEmployees": "All employees",
    "employeeFilter": "Employee",
    "employeeFilterPlaceholder": "All employees in your view",
    "periodMonth": "This month",
    "periodWeek": "This week",
    "periodCustom": "Custom range",
    "formats": {
      "CSV": "CSV",
      "EXCEL": "Excel"
    },
    "tabs": {
      "exports": "Standard exports",
      "payrollHandoff": "Payroll handoff"
    },
    "payrollHandoff": {
      "title": "Payroll handoff",
      "description": "Review payroll readiness, dynamic allowances, approved expenses, claims, attendance, timesheets, and payroll preview before payroll generation.",
      "year": "Year",
      "month": "Month",
      "employeeId": "Employee ID",
      "downloadCsv": "Download CSV",
      "downloadExcel": "Download Excel",
      "invalidPeriod": "Enter a valid year and month",
      "employeesReady": "Employees ready",
      "payrollExceptions": "Payroll exceptions",
      "totalPayrollCost": "Total payroll cost",
      "reimbursementCost": "Expense & claim cost",
      "allowanceCost": "Allowance cost",
      "expenseCost": "Expense cost",
      "claimCost": "Claim cost",
      "attendanceSummary": "Attendance summary",
      "workedDays": "Worked",
      "leaveDays": "Leave",
      "overtime": "Overtime",
      "lateHours": "Late",
      "payrollComponents": "Payroll components",
      "basicSalary": "Basic salary",
      "variableEarnings": "Variable earnings",
      "deductions": "Deductions",
      "netPayPreview": "Net pay preview",
      "allowances": "Allowances",
      "expenses": "Expenses",
      "claims": "Claims",
      "validations": "Validations",
      "none": "None",
      "noEmployees": "No employees found for this payroll period."
    },
    "types": {
      "ATTENDANCE": "Attendance",
      "LEAVE": "Leave",
      "OVERTIME": "Overtime",
      "SCHEDULE_COMPLIANCE": "Schedule compliance",
      "PAYROLL_READINESS": "Payroll readiness",
      "PAYROLL": "Payroll",
      "ALLOWANCE_SUMMARY": "Allowance summary",
      "ALLOWANCE_BY_TYPE": "Allowance by type",
      "ALLOWANCE_BY_DEPARTMENT": "Allowance by department",
      "EXPENSE_SUMMARY": "Expense summary",
      "CLAIM_SUMMARY": "Claim summary",
      "PAYROLL_EXCEPTIONS": "Payroll exceptions",
      "PENDING_APPROVALS": "Pending approvals",
      "PAYROLL_VARIANCE": "Payroll variance",
      "PAYROLL_COST_ANALYSIS": "Payroll cost analysis",
      "RECRUITMENT": "Recruitment",
      "TRAINING": "Training",
      "PERFORMANCE": "Performance",
      "ATTRITION": "Attrition",
      "EMPLOYMENT_HISTORY": "Employment history"
    }
  },
  "import": {
    "title": {
      "attendance": "Bulk CSV import — Attendance",
      "shifts": "Bulk CSV import — Shifts",
      "overtime": "Bulk CSV import — Overtime"
    },
    "description": {
      "attendance": "Upload check-in and check-out times. The system calculates worked hours, expected hours, and overtime before import.",
      "shifts": "Upload employee shift assignments by date. Rows are submitted for approval like manual shift changes.",
      "overtime": "Upload standalone overtime requests (hours or minutes) for employees in your visibility scope."
    },
    "steps": "1. Download the sample CSV · 2. Fill in your rows · 3. Upload the file to validate · 4. Import valid rows",
    "expand": "Expand section",
    "collapse": "Collapse section",
    "downloadSample": "Download sample CSV",
    "downloadSampleHint": "Download a CSV template with the correct column headers for your language",
    "selectFile": "Upload CSV file",
    "validating": "Validating…",
    "selectedFile": "Selected: {{name}}",
    "emptyCell": "—",
    "emptyPreview": "No rows to preview",
    "summary": "{{valid}} valid, {{errors}} errors, {{warnings}} warnings — fix errors or import valid rows only.",
    "importAll": "Import all ({{count}} rows)",
    "importValidOnly": "Import valid rows only ({{count}})",
    "templateFilenames": {
      "attendance": "attendance-import-template.csv",
      "shifts": "shifts-import-template.csv",
      "overtime": "overtime-import-template.csv"
    },
    "columns": {
      "row": "Row",
      "employeeCode": "Employee code",
      "status": "Status",
      "messages": "Messages"
    },
    "status": {
      "valid": "Valid",
      "error": "Error",
      "warning": "Warning"
    },
    "preview": {
      "checkIn": "Check in",
      "checkOut": "Check out",
      "workedHours": "Worked (h)",
      "expectedHours": "Expected (h)",
      "overtimeHours": "OT (h)",
      "overtimeType": "OT type",
      "lateMinutes": "Late (min)",
      "assignmentDate": "Date",
      "shiftName": "Shift",
      "overtimeDate": "Date",
      "hours": "Hours"
    },
    "errors": {
      "fileRequired": "Select a CSV file first.",
      "templateDownloadFailed": "Could not download sample CSV.",
      "validationFailed": "CSV validation failed.",
      "importFailed": "CSV import failed."
    },
    "toast": {
      "templateDownloaded": "Sample CSV downloaded.",
      "validated": "Validated {{count}} row(s). Review the preview before importing.",
      "imported": "Imported {{count}} row(s) successfully.",
      "partialFailure": "{{count}} row(s) failed to import — review the preview table.",
      "noRowsImported": "No rows were imported. Fix errors and try again."
    }
  }
}
